import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import NewConsultant from "./NewConsultation";
import styled from "styled-components";
import { CustomLinkBut, CustomBTNDIV } from "../../style/Dashboard";
import { verifyAuth } from "../../authverify";
import { useHistory } from "react-router-dom";
import Horizontal from '../../assets/Ads/Horizontal.jpeg'
import { CustomLinkButLink } from "../../style/Button";
import { Grid } from "@material-ui/core";
const GirdContainer = styled.div`
  display: flex;
  grid-template-columns: 100%;
  @media (max-width: 906px) {
    grid-template-columns: 1fr;
  }
`;
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;
const useStyles = makeStyles((theme) => ({
  root: {},

  button: {
    backgroundColor: "#03b3fb",
    borderRadius: 20,
    display: "flex",
    border: "1px solid #c5c5c5",
    float: "right",
    color: "white",
    fontWeight: "bold",
    fontFamily: "helvetica",
    textTransform: "none",
    width: 1000,
    height: 30,
    fontSize: 15,
    margin: 4,
    "&:hover": {
      backgroundColor: "#0389fb",
    },
  },
}));

export default function Consultation({ selectedBanner, setSelectedBanner, reactCreative, verticalCreative }) {
  const classes = useStyles();
  const history = useHistory();

  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }

  return (
    <div style={{ width: "100%" }}>
      <GirdContainer>
        <Grid container>
          <Grid item lg={`${verticalCreative ? 9 : 12}`} md={12} xs={12}>
            <Grid container>
              <Grid item md={3} xs={12}>
                <Paper
                  style={{
                    color: "#4678ED",
                    fontWeight: 600,
                    maxWidth: "100%",
                    width: "100%",
                    fontSize: "18px",
                    padding: "24px 50px",
                    display: "block",
                    fontFamily:
                      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                  }}
                >
                  New Consultation
                </Paper>
                <Paper
                  style={{
                    color: "#606060",
                    fontWeight: 600,
                    maxWidth: "100%",
                    width: "100%",
                    fontSize: "18px",
                    padding: "24px 50px",
                    display: "block",
                    fontFamily:
                      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                  }}
                >
                  Consultation history
                </Paper>
                {
                  reactCreative &&
                  <div className="bannerAd mobileCss mobCenter" style={{ marginTop: "20px",  }}>
                    <div  className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', marginBottom: "20px"}}>
                      <iframe
                        title="iframe"
                        srcDoc={reactCreative}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          minHeight: '250px',
                          marginBottom: "30px"
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>
                  </div>
                }
              </Grid>
              <Grid item md={9} xs={12}>
                <div className={`consulatantSection ${verticalCreative ? '' : 'withoutCreative'}`}>
                  <div className="consultantForm">
                    <NewConsultant
                      selectedBanner={selectedBanner}
                      setSelectedBanner={setSelectedBanner}
                    />
                    <div className="text-right customeButtons" style={{ marginTop: "20px" }}>
                      <CustomLinkButLink className="button" to="/People/dashboard">
                        Back
                      </CustomLinkButLink>

                      <CustomLinkButLink className="button" to="/People/Procedures">
                        Next
                      </CustomLinkButLink>

                    </div>
                  </div>

                </div>
              </Grid>
            </Grid>

          </Grid>
          {
            verticalCreative &&
            <Grid item lg={3} md={12} xs={12}>
              <div className="rightIframe  d-flex justify-content-end">
                <div  className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px', }}>
                  <iframe
                    title="iframe"
                    srcDoc={verticalCreative}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '100%',
                      minHeight: '600px',
                      marginBottom: "30px"
                    }}
                    frameBorder="0"
                    scrolling="no"
                  />
                </div>
              </div>
            </Grid>
          }

        </Grid>
      </GirdContainer>

    </div>
  );
}

{
  /* <Grid item xs={3}>
                
                </Grid>
                <Grid item xs={9}>
                  
                </Grid>
                <Grid item xs={12}>
                  <Button className={classes.button}>Next</Button>
                </Grid> */
}
